export default {
  DEBT_FREE_DATE: 'debt_free_date',
  DEBT_TOTAL_BALANCE: 'debt_total_balance',
  DEBT_TRADELINES: 'debt_tradelines',
  PREVIOUS_DEBT_TOTAL_BALANCE: 'previous_debt_total_balance',
  PREVIOUS_DEBT_TRADELINES: 'previous_debt_tradelines',
  DEBT_SUMMARY: 'debt_summary',
  DEBT_SIMULATOR_RESULTS: 'debt_simulator_results'
};